// SAIR do totem com uma linha discreta contornando o card que esvazia de 100
// a 0 conforme o tempo de inatividade passa (quando zera, a tela volta pra
// inicial sozinha). Lê o início do timer de uma ref e atualiza a cada 250 ms
// só aqui — o resto da tela não re-renderiza. Pedido do dono (10/09/2026).
import { LogOut } from "lucide-react";
import { useEffect, useState } from "react";

export default function BotaoSair({ onSair, inicioRef, timeoutMs, ativo = true }) {
  const [pct, setPct] = useState(100);

  useEffect(() => {
    if (!ativo) { setPct(100); return undefined; }
    const tick = () => {
      const passado = Date.now() - (inicioRef?.current || Date.now());
      setPct(Math.max(0, Math.min(100, 100 - (passado / timeoutMs) * 100)));
    };
    tick();
    const t = setInterval(tick, 250);
    return () => clearInterval(t);
  }, [ativo, inicioRef, timeoutMs]);

  return (
    <div className="relative" data-e2e="sair-wrapper">
      <button
        type="button"
        onClick={onSair}
        data-e2e="botao-sair"
        className="w-full h-12 rounded-xl bg-red-600 hover:bg-red-500 text-white font-black text-sm tracking-widest flex items-center justify-center gap-2 active:scale-95 transition-transform shadow-lg shadow-red-900/40"
      >
        <LogOut className="w-4 h-4" /> SAIR
      </button>
      {/* contorno = progresso do tempo até voltar pra tela inicial (100 → 0) */}
      <svg className="absolute -inset-[3px] w-[calc(100%+6px)] h-[calc(100%+6px)] pointer-events-none" viewBox="0 0 200 54" preserveAspectRatio="none" aria-hidden="true">
        <rect
          x="1" y="1" width="198" height="52" rx="13"
          fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="1.5" vectorEffect="non-scaling-stroke"
          pathLength="100" strokeDasharray="100" strokeDashoffset={100 - pct}
          style={{ transition: "stroke-dashoffset 250ms linear" }}
          data-e2e="sair-progresso" data-pct={Math.round(pct)}
        />
      </svg>
    </div>
  );
}
